__turbopack_context__.v({
  "subheading": "jC2bpW_subheading",
});
